import { TableCell, TableRow } from "@material-ui/core";
import { React } from "react";
import TeamRowHeader from "./TeamRowHeader";
import TeamSet from "./TeamSet";

const TeamRow = ({ match, columns, teamSide, team }) => {
	const {
		winnerId,
		isSingle,
		sets = [],
		tiebreakSets = [],
		tiebreakPoints = []
	} = match;
	const matchTeam = match[teamSide];
	const isWinner = matchTeam.teamId === winnerId;

	return (
		<TableRow key={match[teamSide].id}>
			{columns.map((c) => (
				<>
					{c.isHeader && (
						<TableCell align="center" key={c.index}>
							<TeamRowHeader
								isWinner={isWinner}
								isSingle={isSingle}
								team={team}
								matchTeam={matchTeam}
							/>
						</TableCell>
					)}
					{(c.isAction || c.display) && (
						<TableCell align="center" key={c.index}>
							{c.isSet && (
								<TeamSet set={sets[c.index] ? sets[c.index][teamSide] : {}} />
							)}
							{c.isTiebreakSet && (
								<TeamSet
									set={tiebreakSets[c.index] ? tiebreakSets[c.index][teamSide] : {}}
								/>
							)}
							{c.isTiebreakPoints && (
								<TeamSet
									set={{
										score: tiebreakPoints[teamSide]
									}}
								/>
							)}
						</TableCell>
					)}
				</>
			))}
		</TableRow>
	);
};

export default TeamRow;
